document.onreadystatechange = function() {
  if (document.readyState == "interactive") {
    if (screen.width <= 1200) {
      $(".container-stories").click(function(){
        if($(".escolha").is(":visible")){
          $(".escolha").hide();
        }else{
          $(".escolha").show();
        }
      });

      $(".escolha").click(function(event){
        event.stopPropagation();
      });
    };
    $('.stories-full').show();
    $('.stories-slide').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 6,
      arrows: true,
      prevArrow: $('.arrows-ar.prev'),
      nextArrow: $('.arrows-ar.next'),
      responsive: [
        {
          breakpoint: 1638,
          settings: {
            arrows: true,
            slidesToShow: 6,
            slidesToScroll: 6
          }
        },
        {
          breakpoint: 1300,
          settings: {
            arrows: true,
            slidesToShow: 5,
            slidesToScroll: 5
          }
        },
        {
          breakpoint: 600,
          settings: {
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
    $('.slide-destaque').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    });
    $('.spotlight-3-blocks').slick({
      arrows: true,
      slidesToShow: 3,
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    $('[data-toggle="modal"]').click(function(){
      console.log("")
      setTimeout(function(){ 
        $('.slide-destaque').slick('refresh'); 
      }, 300);
    });
  } 
  if (screen.width <= 1200) {
    $('.meganu-open').click(function() { 
      event.preventDefault();
      $(this).parent().children('.sub-menu-mobile').toggleClass('sub-menu-open');
    });
  }
  (function ($) {
    var body = $('body'),
        doc = $(document),
        html = $('html'),
        win = $(window),
        wrapperOverlaySlt = '.wrapper-overlay',
        iconNav,
        dropdownCart,
        miniProductList;
  
    var sidebarCart = $('#sidebar-cart'),
        checkPresente = sidebarCart.find('#check-presente'),
        btnRemove = sidebarCart.find('.btn-remove'),
        sidebarCartNoItems = sidebarCart.find('.cart-empty'),
        sidebarCartHasItems = sidebarCart.find('.mini-products-list'),
        sidebarCartFooter = sidebarCart.find('.cart-footer');

    doc.ready(function () {
      dropdownCart = $('#dropdown-cart'),
      miniProductList = dropdownCart.find('.mini-products-list');
      

      let searchParams = new URLSearchParams(window.location.search)
      var cartOpen = searchParams.has('cart_show');

      if(cartOpen){
        $('html').addClass('cart-show');
      }
    });

    $('#check-presente').on("click", function() {
      window.presenteEmbrulho();
    });
  
    $(document).on("click", "#cart-item-39450874118199", function (event) {
      event.preventDefault();
    });


})(jQuery);
  $(document).ready(function() {
    /* Frete lateral */
    function copyToClipboard(element) {
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val($(element).text()).select();
      document.execCommand("copy");
      $(element).text('copiado');
      setTimeout( function() { $(element).text($temp.val()); $temp.remove(); }, 3000);
    }
    /*Frete Lateral*/
    function limpa_formulário_cep() {
      /*Limpa valores do formulário de cep.*/
      $("#cep-frete").val("");
      $("#pais-frete").val("");
      $("#estado-frete").val("");
    };
    function buscarCEP(inputCEP){
  
      /*Nova variável "cep" somente com dígitos.*/
      var cep = inputCEP.val().replace(/\D/g, '');
      var cepLimpo = inputCEP.val().replace(/\D/g, '');
  
      /*Verifica se campo cep possui valor informado.*/
      if (cep != "") {
  
        /*Expressão regular para validar o CEP.*/
        var validacep = /^[0-9]{8}$/;
  
        /*Valida o formato do CEP.*/
        if(validacep.test(cep)) {
  
          /*Consulta o webservice viacep.com.br*/
          $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {
            if (!("erro" in dados)) {
  
              switch(dados.uf){
                case 'AC': dados.uf = 'Acre'; break;
                case 'AL': dados.uf = 'Alagoas'; break;
                case 'AP': dados.uf = 'Amapa'; break;
                case 'AM': dados.uf = 'Amazonas'; break;
                case 'BA': dados.uf = 'Bahia'; break;
                case 'CE': dados.uf = 'Ceara'; break;
                case 'DF': dados.uf = 'Distrito Federal'; break;
                case 'ES': dados.uf = 'Espirito Santo'; break;
                case 'GO': dados.uf = 'Goias'; break;
                case 'MA': dados.uf = 'Maranhao'; break;
                case 'MT': dados.uf = 'Mato Grosso'; break;
                case 'MS': dados.uf = 'Mato Grosso do Sul'; break;
                case 'MG': dados.uf = 'Minas Gerais'; break;
                case 'PA': dados.uf = 'Para'; break;
                case 'PB': dados.uf = 'Paraiba'; break;
                case 'PR': dados.uf = 'Parana'; break;
                case 'PE': dados.uf = 'Pernambuco'; break;
                case 'PI': dados.uf = 'Piaui'; break;
                case 'RJ': dados.uf = 'Rio de Janeiro'; break;
                case 'RN': dados.uf = 'Rio Grande do Norte'; break;
                case 'RS': dados.uf = 'Rio Grande do Sul'; break;
                case 'RO': dados.uf = 'Rondonia'; break;
                case 'RR': dados.uf = 'Roraima'; break;
                case 'SC': dados.uf = 'Santa Catarina'; break;
                case 'SP': dados.uf = 'Sao Paulo'; break;
                case 'SE': dados.uf = 'Sergipe'; break;
                case 'TO': dados.uf = 'Tocantins'; break;
              }; 
  
              console.log(dados.uf);
  
              //Atualiza os campos com os valores da consulta.
              $("#cep-frete").val(dados.cep);
              $("#pais-frete").val("Brazil");
              $("#estado-frete").val(dados.uf);
  
              var cep = cep,
                  pais = $("#pais-frete").val(),
                  estado = $("#estado-frete").val();
  
              console.log(cepLimpo);
  
              $.ajax({
                type: "GET", //rest Type
                dataType: "json", //mispelled
                url: "/cart/shipping_rates.json?shipping_address%5Bzip%5D="+cepLimpo+"&shipping_address%5Bcountry%5D="+pais+"&shipping_address%5Bprovince%5D="+estado,
                beforeSend: function() {
                  $('.overlay-carregando').show();
                },
                success: function (msg) {
  
                  if (msg.shipping_rates[0].price == "0.00"){
                    $(".preco-frete").html("Grátis");
                  }else{
                    $(".preco-frete").html("R$ "+msg.shipping_rates[0].price);
                  }
  
                  $("#fretes-disponiveis").empty();
  
                  for(i = 0; i < msg.shipping_rates.length; i++) {
                    if (msg.shipping_rates[i].price == "0.00"){
                      $("#fretes-disponiveis").append(new Option(msg.shipping_rates[i].name+" - grátis", [i]));
                    }else{
                      if (msg.shipping_rates[i].delivery_days[1] == "0"){
                        $("#fretes-disponiveis").append(new Option(msg.shipping_rates[i].name+" - R$ "+msg.shipping_rates[i].price, [i]));
                      }else{
                        $("#fretes-disponiveis").append(new Option(msg.shipping_rates[i].name+" - R$ "+msg.shipping_rates[i].price+" ("+msg.shipping_rates[i].delivery_days[1]+" dias úteis)", [i]));
                      }
                    };
  
                    $("#fretes-disponiveis > option[value='"+[i]+"']").attr("data-valor", msg.shipping_rates[i].price);
                  }             
                  $(".resultado-frete-lateral").show();
  
  
                  $('.overlay-carregando').hide();
  
                  jQuery.getJSON('/cart.js', function(cart) {
                    var subtotal = cart.total_price;
                    var frete = parseInt($('#fretes-disponiveis').find(":selected").data("valor").toString().replace(".", ""));
                    var total = subtotal + frete;
  
                    $('.label-total-preco').html(
                      Shopify.formatMoney(total, window.money_format)
                    );   
  
                  });
                  $('.total-carrinho').show();
  
                  setTimeout(function() {$('#fretes-disponiveis').click(); console.log("Teste")}, 2000);
  
                },
                error: function(erro) {
                  $(".resultado-frete-lateral").hide();
                  $(".preco-frete").html("--");
                  limpa_formulário_cep();
                  $('.overlay-carregando').hide();
                  $('.total-carrinho').hide();
                }
              });
            } //end if.
            else {
              //CEP pesquisado não foi encontrado.
              limpa_formulário_cep();
              $(".resultado-frete-lateral").hide();
              $(".overlay-carregando").hide();
              alert("CEP não encontrado.");
              $('.total-carrinho').hide();
            }
          });
        } //end if.
        else {
          //cep é inválido.
          limpa_formulário_cep();
          $(".resultado-frete-lateral").hide();
          alert("Formato de CEP inválido.");
          $('.overlay-carregando').hide();
          $('.total-carrinho').hide();
        }
      } /*end if.*/
      else {
        //cep sem valor, limpa formulário.
        limpa_formulário_cep();
      }
    };
    $("#cep-frete").blur(function(){
      /*$('.overlay-carregando').show();*/
      buscarCEP($(this));
    });
    $("#cep-frete").on('keyup', function () {
      var numeros = $(this).val().replace(/\D/g, '').length;
  
      if(numeros == 8){
        $('.overlay-carregando').show();
        setTimeout(function(){$("#cep-frete").blur();}, 500);
      }
    });
    $("#cep-frete").on('keyup', function (event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13'){
        $('.overlay-carregando').show();
        buscarCEP($(this)); 
      }
    });
    $("#fretes-disponiveis").change(function() {
      console.log($(this).find(':selected').data('valor'));
      var precoItem = $(this).find(':selected').data('valor');
  
      if(precoItem != 0.00){
        $(".preco-frete").html("R$ "+precoItem);
      }else{
        $(".preco-frete").html('GRÁTIS');
      }
  
      jQuery.getJSON('/cart.js', function(cart) {
        var subtotal = cart.total_price;
        var frete = parseInt($('#fretes-disponiveis').find(":selected").attr('data-valor').toString().replace(".", ""));
        var total = subtotal + frete;
  
        $('.label-total-preco').html(
          Shopify.formatMoney(total, window.money_format)
        );  
  
      });
  
      $('.total-carrinho').show();
  
    });   

    $(document).on("click", "[filter-mobile-open]", function() {
      $('html').addClass('sidebar-open');
    });
    
  });
}

window.onload = function() {

    document.addEventListener('long-press', function(e) {
        e.preventDefault();
        console.log("Teste")
    });

    document.addEventListener('any', function(e) {
        console.log(e.type);
    })
}

$(document).ready(function () {
    let searchParams = new URLSearchParams(window.location.search)
    var cartOpen = searchParams.has('cart_show');

    if(cartOpen){
      $('html').addClass('cart-show');
    }
    
})

/* Vitrine da home renderizada no servidor: monta o carrossel aqui mesmo, sem
   depender do loaderProductCard do tema, que so dispara quando a secao entra
   na tela e nao chegava a rodar no desktop. */
/* Titulo manuscrito dentro do painel que abre no menu do topo.
   O tema nao tem esse elemento, entao ele e criado aqui a partir do
   proprio nome da entrada do menu. */
$(document).ready(function () {
  $('.site-nav > li.dropdown').each(function () {
    var $li = $(this);
    var $dd = $li.find('.sub-menu-mobile').first();
    if (!$dd.length) $dd = $li.find('.site-nav-dropdown').first();
    if (!$dd.length || $dd.find('.ninou-drop-titulo').length) return;
    var nome = $li.children('a').first().clone().children().remove().end().text();
    nome = $.trim(nome);
    if (!nome) return;
    nome = nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase();
    $dd.prepend('<span class="ninou-drop-titulo">' + nome + '</span>');
  });
});

$(document).ready(function () {
  $('[data-selfrendered-carousel]').each(function () {
    var $section = $(this);
    var $grid = $section.find('.products-grid').first();

    if (!$grid.length) return;
    if ($grid.hasClass('slick-initialized')) return;
    if (!$grid.find('.grid-item').length) return;

    var perRow = parseInt($grid.data('row'), 10);
    if (!perRow || perRow < 1) perRow = 4;

    $grid.slick({
      slidesToShow: perRow,
      slidesToScroll: perRow,
      speed: 1000,
      infinite: false,
      dots: false,
      arrows: true,
      nextArrow: '<button type="button" aria-label="Proximos produtos" class="slick-next"><i class="fa fa-angle-right"></i></button>',
      prevArrow: '<button type="button" aria-label="Produtos anteriores" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: Math.min(perRow, 3),
            slidesToScroll: Math.min(perRow, 3),
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: Math.min(perRow, 3),
            slidesToScroll: Math.min(perRow, 3),
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            dots: false
          }
        }
      ]
    });
  });
})

/* Filtro de tamanho da pagina de colecao: abre o painel e, ao marcar um
   tamanho, recarrega a pagina ja filtrada pela propria loja. */
$(document).ready(function () {
  var $form = $('[data-ninou-filtro]');
  if (!$form.length) return;
  var $botao = $form.find('[data-ninou-abre]');
  var $painel = $form.find('.ninou-tamanho-painel');

  $botao.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var aberto = !$painel.prop('hidden');
    $painel.prop('hidden', aberto);
    $botao.attr('aria-expanded', aberto ? 'false' : 'true');
  });

  $painel.on('click', function (e) { e.stopPropagation(); });

  $(document).on('click', function () {
    if (!$painel.prop('hidden')) {
      $painel.prop('hidden', true);
      $botao.attr('aria-expanded', 'false');
    }
  });

  /* A loja tem grafias diferentes para o mesmo tamanho ("P 0m-3m" e
     "P 0-3m"). Aqui elas viram uma opcao so, que marca todas as grafias
     de uma vez. */
  function chave(t) {
    return t.toLowerCase().replace(/\s+/g, '').replace(/m-/g, '-').replace(/m$/, '');
  }
  function ordem(t) {
    var s = t.toLowerCase();
    var anos = s.match(/(\d+)\s*anos?/);
    if (anos) return 1000 + parseInt(anos[1], 10);
    var tab = { pp: 0, p: 1, m: 2, g: 3, gg: 4 };
    var pre = (s.match(/^[a-z]+/) || [''])[0];
    var base = tab[pre] === undefined ? 9 : tab[pre];
    var nums = s.match(/\d+/g) || ['0', '0'];
    return base * 100 + parseInt(nums[0], 10) + (parseInt(nums[1] || '0', 10) / 100);
  }

  var grupos = {};
  $painel.find('label').each(function () {
    var $l = $(this);
    var campo = $l.find('input').get(0);
    var txt = $l.find('span').text().trim();
    if (!campo || !txt) return;
    var k = chave(txt);
    if (!grupos[k]) grupos[k] = { rotulo: txt, campos: [], ativo: false };
    if (txt.length > grupos[k].rotulo.length) grupos[k].rotulo = txt;
    grupos[k].campos.push(campo);
    if (campo.checked) grupos[k].ativo = true;
  });

  var chaves = Object.keys(grupos).sort(function (a, b) {
    return ordem(grupos[a].rotulo) - ordem(grupos[b].rotulo);
  });
  if (!chaves.length) return;

  var $limpar = $painel.find('.ninou-limpar').detach();
  var $ocultos = $('<div class="ninou-filtro-ocultos"></div>').hide();
  $painel.empty().append($ocultos);

  chaves.forEach(function (k) {
    var g = grupos[k];
    g.campos.forEach(function (c) { $ocultos.append(c); });
    var $l = $('<label></label>').toggleClass('ativo', g.ativo);
    var $c = $('<input type="checkbox">').prop('checked', g.ativo);
    $l.append($c).append($('<span></span>').text(g.rotulo));
    $c.on('change', function () {
      var marcado = $c.prop('checked');
      g.campos.forEach(function (c) { c.checked = marcado; });
      $form.get(0).submit();
    });
    $painel.append($l);
  });
  if ($limpar.length) $painel.append($limpar);

  var ativos = chaves.filter(function (k) { return grupos[k].ativo; }).length;
  $botao.text(ativos ? 'Tamanho (' + ativos + ')' : 'Tamanho');
});

/* Vistos recentemente: o tema ia reduzindo sozinho a quantidade por linha
   conforme a largura da tela (chegava a mostrar 4 no computador). Aqui o
   carrossel e remontado com 6 por linha fixos no computador, 3 no tablet e
   2 no celular. */
$(document).ready(function () {
  var seletor = '#recently-viewed-products-grid';
  var feito = false;

  function remonta() {
    var $g = $(seletor);
    if (feito || !$g.length || !$g.hasClass('slick-initialized')) return feito;
    try {
      $g.slick('unslick');
      /* Com menos vistos que a quantidade por linha, o modo infinito clona os
         cards e o mesmo produto aparece duas vezes. Nesse caso ele fica de fora. */
      var porLinha = 6;
      $g.slick({
        infinite: $g.children().length > porLinha,
        speed: 600,
        slidesToShow: porLinha,
        slidesToScroll: porLinha,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" aria-label="Anterior" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
        nextArrow: '<button type="button" aria-label="Proximo" class="slick-next"><i class="fa fa-angle-right"></i></button>',
        responsive: [
          { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 3, arrows: false, dots: true } },
          { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2, arrows: false, dots: true } }
        ]
      });
      feito = true;
    } catch (e) {
      return false;
    }
    return true;
  }

  var tentativas = 0;
  var relogio = setInterval(function () {
    tentativas += 1;
    if (remonta() || tentativas > 60) clearInterval(relogio);
  }, 250);
});

/* Contador da sacola no topo: esconde quando a sacola fica vazia.
   O tema reescreve [data-cart-count] com o total (inclusive 0) a cada
   mudanca no carrinho; aqui so alternamos a classe is-empty no conteiner. */
$(document).ready(function () {
  function atualizaContador(el) {
    var n = parseInt($.trim($(el).text()), 10);
    $(el).closest('.cart-count-bubble, .cart-count-bubble-mobile').toggleClass('is-empty', !(n > 0));
  }
  $('[data-cart-count]').each(function () {
    var el = this;
    atualizaContador(el);
    if (window.MutationObserver) {
      new MutationObserver(function () { atualizaContador(el); })
        .observe(el, { childList: true, characterData: true, subtree: true });
    }
  });
});
